export const OPEN_LOT_STATUS_ID = '56FB3D42-FBF9-4524-BE6D-E6806A05B321';
